import { render, staticRenderFns } from "./TabNews.vue?vue&type=template&id=233ddb8c&scoped=true"
import script from "./TabNews.vue?vue&type=script&lang=js"
export * from "./TabNews.vue?vue&type=script&lang=js"
import style0 from "./TabNews.vue?vue&type=style&index=0&id=233ddb8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ddb8c",
  null
  
)

export default component.exports